import React, { useEffect } from "react"
import { Navigate, useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import VerticalLayout from "components/VerticalLayout"
import HorizontalLayout from "components/HorizontalLayout"

//constants
import { layoutTypes } from "../../constants/layout"

const Usermiddleware = props => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
  }, [location])

  const layoutType = useSelector(state => state.Layout.layoutType)
  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)

  const getLayout = layoutType => {
    let Layout = VerticalLayout
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout
        break
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout
        break
      default:
        break
    }
    return Layout
  }

  const Layout = getLayout(layoutType)

  if (token === null) {
    navigate("/login", { state: { from: location.pathname } })
    // return (
    //   <Navigate to={{ pathname: "/login", state: { from: location.pathname } }} />
    // )
  } else if (user && user.user_type === "admin") {
    navigate("/unauthorized")
  }

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>
  )
}

export default Usermiddleware
